import React from "react";
import "../../styles/ActivityTab.css";

const ActivityTab = ({ payment }) => {

    const activities = payment?.activities || [];

    return (

        <div className="activity-card">

            <h3>Payment Timeline</h3>

            {
                activities.length === 0 ? (

                    <p>No Activities Found</p>

                ) : (

                    activities.map((item, index) => (

                        <div
                            className="activity-item"
                            key={index}
                        >

                            <h4>{item.action}</h4>

                            <p>{item.description}</p>

                            <small>
                                {new Date(item.createdAt).toLocaleString()}
                            </small>

                        </div>

                    ))

                )
            }

        </div>

    );

};

export default ActivityTab;